import React, { useState } from 'react';
import { Card, Input, Button, Typography, message } from 'antd';

const { Text } = Typography;

const EditFileContent = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handlePasswordSubmit = () => {
    // For demo purposes, using a simple password. In a real app, this should be properly secured
    if (password === 'admin123') {
      setIsAuthenticated(true);
      messageApi.success('Access granted');
    } else {
      messageApi.error('Invalid password');
    }
  };

  const ProtectedContent = () => (
    <div>
      <Text strong style={{ display: 'block', marginBottom: 16 }}>Vi Editor Commands:</Text>
      
      <div style={{ marginBottom: 16 }}>
        <Text>1. Navigate to file location:</Text>
        <pre style={{  padding: 8, borderRadius: 4 }}>
          cd [file path]
        </pre>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Text>2. Open file in Vi editor:</Text>
        <pre style={{  padding: 8, borderRadius: 4 }}>
          vi [filename]
        </pre>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Text>3. Search for text:</Text>
        <pre style={{  padding: 8, borderRadius: 4 }}>
          /[text to search]
        </pre>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Text>4. Edit mode:</Text>
        <ul>
          <li>Press 'i' to enter insert mode</li>
          <li>Make your changes</li>
          <li>Press 'ESC' to exit insert mode</li>
        </ul>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Text>5. Save and exit:</Text>
        <pre style={{  padding: 8, borderRadius: 4 }}>
          :wq!
        </pre>
      </div>
    </div>
  );

  return (
    <Card title="Edit File Content" bordered={false}>
      {contextHolder}
      {!isAuthenticated ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Text style={{ display: 'block', marginBottom: 16 }}>
            Please enter password to view content:
          </Text>
          <Input.Password
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: 200, marginRight: 8 }}
            onPressEnter={handlePasswordSubmit}
          />
          <Button type="primary" onClick={handlePasswordSubmit}>
            Submit
          </Button>
        </div>
      ) : (
        <ProtectedContent />
      )}
    </Card>
  );
};

export default EditFileContent; 